import { render } from "./CellTags.vue?vue&type=template&id=b574d2a6&lang=pug"
import script from "./CellTags.vue?vue&type=script&lang=js"
export * from "./CellTags.vue?vue&type=script&lang=js"

import "./CellTags.vue?vue&type=style&index=0&id=b574d2a6&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__